import type { InvestigationLabels, ResearchScope } from '@/frontend/features/Fde/investigations/types'

export default function ResearchScopePicker({ value, onChange, copy, disabled }: {
  value: ResearchScope; onChange: (value: ResearchScope) => void; copy: InvestigationLabels; disabled: boolean
}) {
  return <fieldset className="grid gap-3" disabled={disabled}>
    <legend className="mb-2 text-sm font-medium">{copy.research_scope}</legend>
    <div className="grid gap-2 sm:grid-cols-3">
      {(['project', 'forge', 'combined'] as const).map((scope) => <label key={scope} className={`flex cursor-pointer items-start gap-2.5 rounded-lg border p-3 ${value === scope ? 'border-foreground/35 bg-muted/50' : 'border-border hover:bg-muted/25'}`}>
        <input type="radio" name="research-scope" aria-label={copy[`research_scope_${scope}`]} value={scope} checked={value === scope} onChange={() => onChange(scope)} className="mt-0.5 accent-foreground" />
        <span className="grid gap-1"><span className="text-sm font-medium">{copy[`research_scope_${scope}`]}</span><span className="text-xs leading-relaxed text-muted-foreground">{copy[`research_scope_${scope}_hint`]}</span></span>
      </label>)}
    </div>
  </fieldset>
}
